import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPost, apiPut } from './api';
const { REACT_APP_ORGANIZATION } = process.env;

type TDataKam = {
  organizationId: string | number;
  kamUserId: string | number;
};
export const assignKam = async (data: TDataKam) => {
  return apiPost<AxiosRequestConfig, TDataKam>(`${REACT_APP_ORGANIZATION}/organization/backoffice/kam/assign`, data)
    .then(resp => {
      const response: string = resp;
      return response;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};
